module.exports = __webpack_public_path__ + "static/media/happy9.6fa6108f.svg";